import * as yup from 'yup';
import { HeroBadges } from '@web/components';
import { schema as badgeSchema } from './hero_badge.js';

export const component = HeroBadges;

export const schema = yup
  .object({
    badges: yup.array(badgeSchema),
    fontColor: yup.string(),
  })
  .transform(value => ({
    component: 'hero_badges',
    badges: value.badges,
    fontColor: value.font_color || undefined,
  }));
